// extracted by mini-css-extract-plugin
export default {"container":"AV-z","title":"BV-z","link":"CV-z"};